import React from "react";
import { AnimaDiv, Coefficient, WheelDiv } from "./WheelStyled";
export default function Wheel({ coeffs }) {
  return (
    <WheelDiv>
      <AnimaDiv>
        {coeffs.map((e, i) => (
          <Coefficient
            key={i}
            index={i}
            bcc={e.background}
            length={coeffs.length}
          >
            {e.coef}
          </Coefficient>
        ))}
      </AnimaDiv>
    </WheelDiv>
  );
}
